/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost
 */
export interface ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost {
    /**
     * 
     * @type {string}
     * @memberof ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost
     */
    file: string;
}

/**
 * Check if a given object implements the ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost interface.
 */
export function instanceOfControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "file" in value;

    return isInstance;
}

export function ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPostFromJSON(json: any): ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost {
    return ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPostFromJSONTyped(json, false);
}

export function ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': json['file'],
    };
}

export function ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPostToJSON(value?: ControlBodyUploadIgnoreFindingsBlocklistEvidenceAsmEntityEntityIdFindingsIgnoredIgnoredIdPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
    };
}

